import { APP_COLOR } from "../../../theme";

export const styles = {
  controls: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  } as const,
  icons: {
    height: 25,
    width: 25,
    margin: "2px 0",
    color: "black",
    backgroundColor: APP_COLOR,
    borderRadius: "50%",
  } as const,
  bpmButtons: {
    padding: "2px",
    margin: "2 0",
    maxWidth: "25px",
    maxHeight: "25px",
    minWidth: "25px",
    minHeight: "25px",
    "&:hover": {
      backgroundColor: APP_COLOR,
    },
    borderRadius: "50%",
    backgroundColor: APP_COLOR,
    color: "black",
  } as const,
  exportBtn: {
    marginLeft: "10px",
    color: "white",
    backgroundColor: "#28B6CB",
    ":disabled": {
      backgroundColor: "#93c3c9",
    },
  } as const,
};
